export class ColorModel {
  primary: string;
  secondary: string;
  accent: string;

  constructor(obj: any = null) {
    this.primary = obj?.primary
    this.secondary = obj?.secondary
    this.accent = obj?.accent
  }
}
